const updates = [
  {
    date: '2026.08.01',
    title: '《暗潮》全网首发上线',
    desc: '悬疑巨制《暗潮》今日在春色影视全网首发，高清1080P版本同步上线，不缓冲秒开体验。',
  },
  {
    date: '2026.07.30',
    title: '暑期档专题页面上线',
    desc: '「夏日观影季」专题正式推出，汇总暑期最热门电影电视剧，一站式浏览最新影视资源。',
  },
  {
    date: '2026.07.28',
    title: '播放引擎全面升级',
    desc: 'CDN节点扩展至全球200+城市，播放缓冲时间再降40%，高峰时段也能保持秒开无卡顿。',
  },
  {
    date: '2026.07.25',
    title: '《山河纪》第三季开播',
    desc: '万众期待的《山河纪》第三季首播，前三集同步上线，弹幕互动功能同步开放。',
  },
  {
    date: '2026.07.22',
    title: '移动端体验优化完成',
    desc: '手机浏览器观看体验大幅升级，适配全面屏和折叠屏设备，流量优化节省30%带宽。',
  },
  {
    date: '2026.07.18',
    title: '纪录片频道内容扩充',
    desc: '新增200+部高分纪录片，涵盖自然、历史、科技等多个领域，全部提供高清免费在线观看。',
  },
  {
    date: '2026.07.15',
    title: '智能推荐算法上线',
    desc: '基于观看偏好的智能推荐系统正式运行，帮助用户更快发现感兴趣的影视内容。',
  },
];

export default function SectionUpdates() {
  return (
    <section id="updates" className="py-16 md:py-20 px-4 md:px-8 bg-background-100">
      <div className="max-w-[900px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50 mb-3">
            最新动态
          </h2>
          <p className="text-sm text-foreground-400">春色影视平台更新与内容资讯</p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] md:left-[23px] top-2 bottom-2 w-px bg-background-300/30"></div>

          <div className="space-y-6">
            {updates.map((item, i) => (
              <div key={i} className="relative flex gap-5 md:gap-6 pl-12 md:pl-14">
                <div className="absolute left-0 top-1 w-4 h-4 md:w-5 md:h-5 rounded-full bg-primary-500/30 border-2 border-primary-500"></div>
                <div className="flex-1 bg-background-200/40 rounded-lg border border-background-300/20 p-4 md:p-5">
                  <div className="flex flex-wrap items-center gap-2 mb-2">
                    <span className="text-xs text-primary-400 font-medium">{item.date}</span>
                    <span className="w-1 h-1 rounded-full bg-foreground-500"></span>
                    <h3 className="text-sm md:text-base font-heading font-bold text-foreground-100">
                      {item.title}
                    </h3>
                  </div>
                  <p className="text-xs md:text-sm text-foreground-400 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}